import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STOKEN_KEY = "eim_student_token";

const StudentAuthContext = createContext(null);

export function StudentAuthProvider({ children }) {
  const [student, setStudent] = useState(undefined); // undefined=loading, null=no auth, object=auth
  const [token, setTokenState] = useState(() => localStorage.getItem(STOKEN_KEY));

  const setToken = useCallback((t) => {
    if (t) localStorage.setItem(STOKEN_KEY, t);
    else localStorage.removeItem(STOKEN_KEY);
    setTokenState(t);
  }, []);

  const fetchMe = useCallback(async (tok) => {
    if (!tok) {
      setStudent(null);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/student/me`, {
        headers: { Authorization: `Bearer ${tok}` },
      });
      setStudent(data);
    } catch (e) {
      setToken(null);
      setStudent(null);
    }
  }, [setToken]);

  useEffect(() => {
    fetchMe(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = useCallback(async (username, password) => {
    const { data } = await axios.post(`${API}/student/login`, { username, password });
    setToken(data.access_token);
    setStudent(data.student);
    return data.student;
  }, [setToken]);

  const logout = useCallback(() => {
    setToken(null);
    setStudent(null);
  }, [setToken]);

  const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <StudentAuthContext.Provider value={{ student, token, login, logout, authHeader }}>
      {children}
    </StudentAuthContext.Provider>
  );
}

export const useStudentAuth = () => {
  const ctx = useContext(StudentAuthContext);
  if (!ctx) throw new Error("useStudentAuth must be used inside StudentAuthProvider");
  return ctx;
};
